<template>
  <div class="custom-function-editor">
    <div class="row">
      <div class="col-md-6">
        <div class="custom-function-editor__input-group">
          <label class="custom-function-editor__label" for="sessionValues">Session Values (JSON)</label>
          <textarea
            id="sessionValues"
            v-model="localSessionValues"
            class="form-control"
            rows="4"
            placeholder="Enter session values in JSON format"
          ></textarea>
        </div>
      </div>
      
      <div class="col-md-6">
        <div class="custom-function-editor__input-group">
          <label class="custom-function-editor__label" for="actionResults">Action Results (JSON)</label>
          <textarea
            id="actionResults"
            v-model="localActionResults"
            class="form-control"
            rows="4"
            placeholder="Enter action results in JSON format"
          ></textarea>
        </div>
      </div>
    </div>

    <div class="custom-function-editor__editor-section">
      <v-ace-editor
        v-model:value="localCode"
        :options="{
          fontSize: 14,
          showPrintMargin: false,
          showGutter: true,
          highlightActiveLine: true,
          enableBasicAutocompletion: true,
          enableSnippets: true,
          enableLiveAutocompletion: true
        }"
        :readonly="false"
        @init="editorInit"
        lang="javascript"
        theme="monokai"
        style="height: 400px"
      />
    </div>

    <div class="custom-function-editor__actions">
      <button type="button" class="btn btn-outline-success btn-lg" @click="saveFunction">Save Function</button>
      <button type="button" class="btn btn-outline-warning btn-lg" @click="testFunction">Test Function</button>
    </div>
  </div>
</template>

<script>
import { VAceEditor } from "vue3-ace-editor";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/theme-monokai";
import "ace-builds/src-noconflict/ext-language_tools";
import api from "@/shared/menuApi";

export default {
  name: 'CustomFunctionEditor',
  components: {
    VAceEditor,
  },
  props: {
    code: {
      type: String,
      default: ''
    },
    sessionValues: {
      type: String,
      default: '{}'
    },
    actionResults: {
      type: String,
      default: '{}'
    }
  },
  data() {
    return {
      localCode: this.code,
      localSessionValues: this.sessionValues,
      localActionResults: this.actionResults
    };
  },
  watch: {
    code(newValue) {
      this.localCode = newValue;
    },
    sessionValues(newValue) {
      this.localSessionValues = newValue;
    },
    actionResults(newValue) {
      this.localActionResults = newValue;
    }
  },
  methods: {
    editorInit(editor) {
      editor.setOptions({
        fontSize: 14,
        showPrintMargin: false,
        showGutter: true,
        highlightActiveLine: true,
        enableBasicAutocompletion: true,
        enableSnippets: true,
        enableLiveAutocompletion: true
      });
    },
    saveFunction() {
      try {
        // Validate JSON inputs
        const sessionValuesJson = JSON.parse(this.localSessionValues || '{}');
        const actionResultsJson = JSON.parse(this.localActionResults || '{}');
        
        // Emit save event with all data
        this.$emit('save', {
          code: this.localCode,
          sessionValues: sessionValuesJson,
          actionResults: actionResultsJson
        });
      } catch (error) {
        console.log(error);
        
      }
    },
    testFunction() {
      try {
        // Validate JSON inputs
        const sessionValuesJson = JSON.parse(this.localSessionValues || '{}');
        const actionResultsJson = JSON.parse(this.localActionResults || '{}');
        
        // Emit test event with all data
        this.$emit('test', {
          code: this.localCode,
          sessionValues: sessionValuesJson,
          actionResults: actionResultsJson
        });
      } catch (error) {
        alert('Invalid JSON in inputs. Please check your JSON format.');
      }
    }
  },
  mounted() {
    // Only fetch docs if the initial code is empty
    
      setTimeout(() => {
          if (!this.localCode) {
                api
                .doGet(`/api/docs/javascript`)
                .then((data) => {
                  console.log("the sdk documentaiton >>"+data)
                  if (data) {
                    this.localCode = data;
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
          }
        }, 1000); 
    
  },
};
</script>

<style scoped>
.custom-function-editor {
  padding: 20px;
}

.custom-function-editor__input-group {
  margin-bottom: 20px;
}

.custom-function-editor__label {
  display: block;
  margin-bottom: 5px;
  color: #fff;
}

.custom-function-editor__editor-section {
  margin-bottom: 20px;
  border: 1px solid #424351;
  border-radius: 4px;
}

.custom-function-editor__actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

.form-control {
  background-color: #2b2e4c;
  color: #fff;
  border: 1px solid #424351;
}

.form-control:focus {
  background-color: #2b2e4c;
  color: #fff;
  border-color: #007bff;
  box-shadow: none;
}

textarea.form-control {
  resize: vertical;
}

.btn {
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.btn-outline-success {
  color: #28a745;
  border-color: #28a745;
}

.btn-outline-success:hover {
  color: #fff;
  background-color: #28a745;
  border-color: #28a745;
}

.btn-outline-warning {
  color: #ffc107;
  border-color: #ffc107;
}

.btn-outline-warning:hover {
  color: #fff;
  background-color: #ffc107;
  border-color: #ffc107;
}
</style> 